import { Button, InputAdornment, Modal, TextField } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import request from '../../../Helpers/API';
import { LoaderScreen } from '../../components/LoaderScreen';
import DeleteIcon from '@mui/icons-material/Delete';

export const ModalModificarImagen = ({ open, handleClose, datos, imagenesBD }) => {
    const [imagenes, setImagenes] = useState([]); // Imagenes nuevas a cargar
    const [imagenesExistentes, setImagenesExistentes] = useState([]); // Imagenes ya cargadas desde BD
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    useEffect(() => {
        if (!open) {
            setImagenes([]);
            setImagenesExistentes([]);
        }
    }, [open]);

    const GetFile = ({ target }) => {
        const files = Array.from(target.files);

        // Calcula el número total de imágenes (existentes + nuevas)
        const totalImagenes = imagenesExistentes.length + files.length;

        if (totalImagenes > 4) {
            Swal.fire("Clientes", "Solo puedes subir hasta 4 imágenes en total", "error");
            target.value = "";
            return;
        }

        const formatosValidos = ["jpg", "jpeg", "png"];
        let nuevasImagenes = [];

        files.forEach((file) => {
            const extension = file.name.split(".").pop().toLowerCase();

            if (!formatosValidos.includes(extension)) {
                Swal.fire("Clientes", "Formato de archivo no válido", "error");
                target.value = "";
                return;
            }

            const fReader = new FileReader();
            fReader.readAsDataURL(file);
            fReader.onloadend = function (event) {
                const nuevaImagen = {
                    documento: event.target.result,
                    extension,
                };

                // Agrega las imágenes nuevas a la lista
                nuevasImagenes.push(nuevaImagen);

                // Si ya cargó todas las imágenes, actualiza el estado
                if (nuevasImagenes.length === files.length) {
                    setImagenes((prevImagenes) => [...prevImagenes, ...nuevasImagenes]);
                }
            };
        });
    };


    const onEliminarImagen = async (id_imagen, index) => {
        setLoader({ ...loader, mostrar: true });
        try {
            await request.get(`ImagenesProductoAliado/EliminarImagenes?id_imagen=${id_imagen}`);
            setImagenesExistentes((prevImagenes) => prevImagenes.filter((_, i) => i !== index));

            setLoader({ ...loader, mostrar: false });
            Swal.fire("Eliminación exitosa", "Imagen eliminada correctamente", "success");
        } catch (error) {
            setLoader({ ...loader, mostrar: false });
            Swal.fire("Error", "No se pudo eliminar la imagen", "error");
        }
    };

    useEffect(() => {
        if (open) {
            if (imagenesBD && imagenesBD.length > 0) {
                const imagenesCargadas = imagenesBD.map(img => ({
                    id_imagen: img.id_imagen,
                    documento: img.documento, // Asegúrate de que `url` contiene la imagen
                    extension: img.extension || "jpg", // Asigna una extensión por defecto si no está definida
                }));
                setImagenesExistentes(imagenesCargadas);
            } else {
                setImagenesExistentes([]); // Si no hay imágenes en BD, limpia el estado
            }
        }
    }, [open, imagenesBD]);

    const onGuardar = () => {
        if (imagenes.length === 0) {
            Swal.fire("Clientes", "No hay imágenes para guardar", "error");
            return;
        }

        setLoader({ ...loader, mostrar: true });

        // Guardar las nuevas imágenes
        imagenes.forEach((img) => {
            const imagenPost = {
                documento: img.documento,
                extension: img.extension,
                idinventario: datos.idinventario, // Asegúrate de que folio tenga el ID correcto
            };

            request
                .post("ImagenesProductoAliado/GuardarImagenes", imagenPost)
                .then(() => {
                    setLoader({ ...loader, mostrar: false });
                    setImagenes([]); // Limpiar imágenes después de guardar
                    handleClose();
                    Swal.fire("CARGA DE IMÁGENES", "Imagen guardada con éxito", "success");
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("CARGA DE IMÁGENES", JSON.stringify(error), "error");
                });
        });
    };

    const onEliminarImagenSubir = (index) => {
        const nuevasImagenes = [...imagenes];
        nuevasImagenes.splice(index, 1);
        setImagenes(nuevasImagenes);
    };

    return (
        <Modal open={open}>
            <div className="imagen-modal">
                <LoaderScreen loader={loader} />
                <div className="imagen-modal-title">
                    <div className="filtro-soy-el-titulo-header">
                        <h3>CAMBIAR IMÁGENES</h3>
                    </div>
                </div>
                <div className="imagen-modal-soy-el-titulo-line">
                    <div className="imagen-modal-soy-el-titulo-line-bl"></div>
                    <div className="imagen-modal-soy-el-titulo-line-circle"></div>
                    <div className="imagen-modal-soy-el-titulo-line-br"></div>
                </div>

                <div>
                    <div>
                        <TextField
                            id="clientes-documento"
                            type="file"
                            onChange={GetFile}
                            inputProps={{ multiple: true, accept: "image/*" }} // Filtra solo imágenes
                            sx={{ mb: 2, width: 540 }}
                        />

                        {imagenesExistentes.length > 0 && (
                            <div className="contenedor-imagenes">
                                {imagenesExistentes.map((img, index) => (
                                    <img
                                        key={index}
                                        src={img.documento}
                                        alt={`imagen-${index}`}
                                        className="imagen-seleccionada"
                                        onClick={() => onEliminarImagen(img.id_imagen, index)}
                                    />
                                ))}
                            </div>
                        )}

                        {imagenes.length > 0 && (
                            <div className="contenedor-imagenes">
                                {imagenes.map((img, index) => (
                                    <img
                                        key={index}
                                        src={img.documento}
                                        alt={`nueva-imagen-${index}`}
                                        className="imagen-seleccionada"
                                        onClick={() => onEliminarImagenSubir(index)}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                <div className="imagen-modal-button-container">
                    <div className="cerrar-button" onClick={handleClose} style={{ cursor: "pointer" }}>
                        Cerrar
                    </div>
                    <div className="right-buttons">
                        {imagenes.length <= 4 && (
                            <div
                                className="agregar-button"
                                onClick={onGuardar}
                                style={{ cursor: "pointer" }}
                            >
                                Agregar
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Modal>
    );
};
